import { GetPlaceholderParams } from '../models/sitecore-layout';
import { sitecoreLayoutHttp } from './sitecore-layout-api';

export const getPlaceholder = async <PlaceholderData>(
  params: GetPlaceholderParams
): Promise<PlaceholderData> => {
  const placeholder = await sitecoreLayoutHttp.get<PlaceholderData>('', {
    params: {
      item: params.item,
      sc_lang: params.locale,
      placeholderName: params.placeholderName,
      ...(params.site && { sc_site: params.site }),
    },
  });
  return await placeholder.data;
};
